<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden bg-card">
    <ng-container *transloco="let t">
        <div
            class="flex justify-between items-center p-8 md:px-15 lg:px-30 xl:px-40 md:py-8 lg:py-8 xl:py-8"
        >
            <div
                class="text-4xl uppercase font-semibold tracking-tight leading-tight"
            >
                {{ t("CREATE-NEW-USER") }}
            </div>

            <button
                class="order-first sm:order-last"
                mat-flat-button
                [color]="'primary'"
                [disabled]="userForm.invalid"
                (click)="save()"
            >
                {{ t("CREATE-NEW") }}
            </button>
        </div>

        <div
            class="flex flex-col flex-1 overflow-auto p-8 md:px-15 lg:px-30 xl:px-40"
        >
            <form [formGroup]="userForm" autocomplete="off">
                <!-- @if (showPartnerId) {
                <mat-form-field class="w-full">
                    <mat-label>{{ t("partnerId") }}</mat-label>
                    <mat-select formControlName="partnerId" name="language">
                        @for (partner of partnerIds; track $index) {
                        <mat-option [value]="partner">
                            {{ partner }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                } -->

                <mat-form-field class="w-full">
                    <mat-label>{{ t("FIRST-NAME") }}</mat-label>
                    <input
                        id="firstName"
                        type="text"
                        matInput
                        formControlName="firstName"
                    />
                    @if (userForm.get('firstName')?.hasError('pattern')) {
                    <mat-error>{{ t("INVALID-FORMAT") }}</mat-error>
                    }
                </mat-form-field>

                <mat-form-field class="w-full">
                    <mat-label>{{ t("LAST-NAME") }}</mat-label>
                    <input
                        id="lastName"
                        type="text"
                        matInput
                        formControlName="lastName"
                    />
                    @if (userForm.get('lastName')?.hasError('pattern')) {
                    <mat-error>{{ t("INVALID-FORMAT") }}</mat-error>
                    }
                </mat-form-field>

                <mat-form-field class="w-full">
                    <mat-label>{{ t("EMAIL") }}</mat-label>
                    <input
                        id="email"
                        type="email"
                        matInput
                        formControlName="email"
                    />
                    @if (userForm.get('email')?.hasError('pattern')) {
                    <mat-error>{{ t("INVALID-FORMAT") }}</mat-error>
                    }
                </mat-form-field>

                <mat-form-field class="w-full">
                    <mat-label>{{ t("PASSWORD") }} </mat-label>
                    <input
                        id="password"
                        matInput
                        type="password"
                        formControlName="password"
                        name="p-field-10"
                        autocomplete="off"
                        #passwordField
                    />
                    <button
                        mat-icon-button
                        type="button"
                        (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        "
                        matSuffix
                    >
                        @if(passwordField.type === 'password'){
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye'"
                        ></mat-icon>

                        } @if(passwordField.type === 'text'){
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye-slash'"
                        ></mat-icon>
                        }
                    </button>
                    @if (userForm.get('password')?.hasError('pattern')) {
                    <mat-error>{{ t("INVALID-FORMAT") }}</mat-error>
                    }
                </mat-form-field>

                <!-- <div formGroupName="passwordForm">
                    <mat-form-field class="w-full">
                        <mat-label>{{ t("PASSWORD") }} </mat-label>
                        <input
                            id="password"
                            matInput
                            type="password"
                            formControlName="password"
                            name="p-field-11"
                        autocomplete="off"
                            #passwordField
                        />
                        <button
                            mat-icon-button
                            type="button"
                            (click)="
                                passwordField.type === 'password'
                                    ? (passwordField.type = 'text')
                                    : (passwordField.type = 'password')
                            "
                            matSuffix
                        >
                            <mat-icon
                                class="icon-size-5"
                                *ngIf="passwordField.type === 'password'"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                            <mat-icon
                                class="icon-size-5"
                                *ngIf="passwordField.type === 'text'"
                                [svgIcon]="'heroicons_solid:eye-slash'"
                            ></mat-icon>
                        </button>

                        @if
                        (userForm.get('passwordForm').get('password')?.hasError('pattern'))
                        {
                        <mat-error>{{ t("INVALID-FORMAT") }}</mat-error>
                        }

                        
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-label>Repeat {{ t("PASSWORD") }}</mat-label>
                        <input
                            id="repeat-password"
                            matInput
                            type="password"
                            formControlName="repeatPassword"
                            name="p-field-12"
                        autocomplete="off"
                            #repeatpPsswordField
                        />
                        <button
                            mat-icon-button
                            type="button"
                            (click)="
                                repeatpPsswordField.type === 'password'
                                    ? (repeatpPsswordField.type = 'text')
                                    : (repeatpPsswordField.type = 'password')
                            "
                            matSuffix
                        >
                            <mat-icon
                                class="icon-size-5"
                                *ngIf="repeatpPsswordField.type === 'password'"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                            <mat-icon
                                class="icon-size-5"
                                *ngIf="repeatpPsswordField.type === 'text'"
                                [svgIcon]="'heroicons_solid:eye-slash'"
                            ></mat-icon>
                        </button>
                    </mat-form-field>

                    @if(userForm.get('passwordForm')
                    .get('repeatPassword').required){
                    <mat-error>
                        Wiederholung des Passworts ist erforderlich
                    </mat-error>
                    }
                    @if(userForm.get('passwordForm').get('repeatPassword').dirty
                    && userForm.get('passwordForm').errors &&
                    userForm.get('passwordForm').errors['PasswordNoMatch']){
                    <mat-error class="error-message">
                        Das Passwort stimmt nicht überein.
                    </mat-error>
                    }
                </div> -->

                <!-- 232345671234562 -->
                <mat-form-field class="w-full">
                    <mat-label>
                        {{ t("IMEI") }}
                        ({{ t("IF-NECESSARY-SCAN-THE-QR-CODE-ON-THE-BACK") }})
                    </mat-label>
                    <input
                        id="imei"
                        type="text"
                        matInput
                        formControlName="imei"
                    />
                    <mat-icon
                        matSuffix
                        class="cursor-pointer"
                        (click)="openAddDeviceWithQRcodeDialog()"
                    >
                        qr_code_scanner
                    </mat-icon>

                    @if (userForm.get('imei')?.hasError('qrCodePattern')) {
                    <mat-error>{{ t("INVALID-FORMAT") }}</mat-error>
                    }
                </mat-form-field>

                <!--  -->
                @if(userForm.get('imei')?.value && userForm.get('imei')?.valid
                && deviceDetails){
                <div class="border-slate-300 mb-4 px-4 py-2 border rounded-md">
                    @if(deviceDetails.number){
                    <div>
                        {{ t("TELEPHONE-NUMBER-TIME") }}: {{ deviceDetails.number }}
                    </div>
                    } @if(deviceDetails.model){
                    <div>
                        {{ t("MODEL") }}: {{ deviceDetails.model }}
                        {{ deviceDetails.modelName }}
                    </div>
                    }
                </div>
                }

                <mat-form-field class="w-full">
                    <mat-label>{{ t("YOUR-IDENTIFICATION-NUMBER") }}</mat-label>
                    <input type="text" matInput formControlName="externalId" />
                </mat-form-field>

                <mat-form-field class="w-full">
                    <mat-label>{{ t("ADDITIONAL-CONTACTS") }}</mat-label>
                    <mat-select [formControl]="contactsCtrl" multiple>
                        <mat-select-trigger>
                            {{getContact($safeNavigationMigration(contactsCtrl.value?.[0])) || ''}}
                            @if ((contactsCtrl.value?.length || 0) > 1) {
                            <span class="example-additional-selection">
                                (+{{ (contactsCtrl.value?.length || 0) - 1 }}
                                {{
                                    contactsCtrl.value?.length === 2
                                        ? t("OTHER")
                                        : t("OTHERS")
                                }})
                            </span>
                            }
                        </mat-select-trigger>
                        @for (contact of contacts; track contact) {
                        <mat-option [value]="contact.id">
                            {{ getName(contact) }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-checkbox formControlName="withDrinkReminder">
                    {{ t("WITH-DRINK-REMINDER") }}
                </mat-checkbox>

                <mat-checkbox formControlName="withStepReminder">
                    {{ t("WITH-STEP-REMINDER") }}
                </mat-checkbox>
            </form>
        </div>
    </ng-container>
</div>
